
import BuyerPortal from "../routes/BuyerPortal/index";
export default function PublicRoutes() {

  return (
   <BuyerPortal />
  )
}
